import includes from "lodash/includes";
import styled from "styled-components";
export const SIZES = {
    HEIGHT: 200,
    DESCRIPTION_ROW_HIGHT: 20
};
export default {
    Container: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["hasDescription"], prop)
    }) `
    height: ${({ hasDescription }) => SIZES.HEIGHT + (hasDescription ? SIZES.DESCRIPTION_ROW_HIGHT : 0)}px;
    display: grid;
    gap: ${({ theme }) => theme["project-gap"]};
    grid-template-rows: ${({ hasDescription }) => (hasDescription ? "auto auto 1fr" : "auto 1fr")};
  `,
    Header: styled.div `
    display: flex;
    gap: 20px;
    justify-content: space-between;
    align-items: center;
  `,
    Title: styled.h5 `
    color: #6745f1;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    display: flex;
    gap: 4px;
    align-items: center;

    &:hover {
      color: #5b21d4;
    }
  `
};
